// src/components/shared/UnsavedChangesPrompt.js
import React from 'react';
import Modal from 'react-modal';
import { FaExclamationTriangle } from 'react-icons/fa';
import './UnsavedChangesPrompt.css';

const UnsavedChangesPrompt = ({
  isOpen,
  onConfirm,
  onCancel,
  title = 'Unsaved Changes',
  message = 'You have unsaved changes. Are you sure you want to leave? Your changes will be lost.',
  confirmText = 'Leave Without Saving',
  cancelText = 'Stay and Keep Editing'
}) => {
  const modalStyles = {
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    },
    content: {
      position: 'relative',
      top: 'auto',
      left: 'auto',
      right: 'auto',
      bottom: 'auto',
      border: 'none',
      background: 'transparent',
      overflow: 'visible',
      padding: 0,
      width: '90%',
      maxWidth: '500px'
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onCancel}
      contentLabel="Unsaved Changes Warning"
      className="unsaved-changes-modal"
      overlayClassName="unsaved-changes-overlay"
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
      closeTimeoutMS={200}
      style={modalStyles}
      ariaHideApp={false}  // Add this if you haven't set the app element
    >
      <div className="unsaved-changes-content">
        <div className="unsaved-changes-header">
          <FaExclamationTriangle className="warning-icon" />
          <h2>{title}</h2>
        </div>
        
        <div className="unsaved-changes-body">
          <p>{message}</p>
        </div>

        <div className="unsaved-changes-actions">
          <button
            type="button"
            onClick={onCancel}
            className="cancel-button"
          >
            {cancelText}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="confirm-button"
          >
            {confirmText}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default UnsavedChangesPrompt;